import {
  ref, reactive,
} from '@vue/composition-api'
import axiosIns from '@/libs/axios'
import { dateFormat } from '@/utils/date-format'
import snakeCaseToCamelCase from '@/utils/snake-case-to-camcel-caase'
import { errorNotification, successNotification } from '@/utils/toast-notifications'

const PLAN_STATUS = {
  created: 'created',
  active: 'active',
  payment_failed: 'payment_failed',
  pending_cancellation: 'pending_cancellation',
  cancelled: 'cancelled',
  expired: 'expired',
}

export default function useSubscribedUsers(ctx) {
  const tableColumns = [
    {
      key: 'state',
      formatter: val => snakeCaseToCamelCase(val),
    },
    {
      key: 'plan',
      label: 'User Type',
      formatter: item => item.target,
    },
    {
      key: 'description',
      label: 'Bundle Name',
      formatter: (item, item2, item3) => item3.plan.name,
    },
    { key: 'next_payment_date', label: 'Renewal Date', formatter: val => dateFormat(val) },
    'actions',
  ]
  const list = ref([])
  const loading = ref(false)
  const total = ref(0)
  const queryParams = reactive({
    target: undefined,
    page: 1,
    name: undefined,
    status: undefined,
    perPage: 10,
  })
  const currTarget = ref('All')
  const currStatus = ref('All')

  const statusOptions = [
    { label: 'All', key: 'All' },
    { label: 'Created', key: PLAN_STATUS.created },
    { label: 'Active', key: PLAN_STATUS.active },
    { label: 'Payment Failed', key: PLAN_STATUS.payment_failed },
    { label: 'Pending Cancellation', key: PLAN_STATUS.pending_cancellation },
    { label: 'Cancelled', key: PLAN_STATUS.cancelled },
    { label: 'Expired', key: PLAN_STATUS.expired },

  ]
  const targetOptions = [
    { label: 'All', key: 'All' },
    { label: 'Drivers', key: 'driver' },
    { label: 'Riders', key: 'rider' },
  ]
  const fetchUsers = async () => {
    loading.value = true
    try {
      const temp = { ...queryParams }
      if (currTarget.value === 'All') {
        temp.target = undefined
      } else {
        temp.target = currTarget.value
      }
      if (currStatus.value === 'All') {
        temp.status = undefined
      } else {
        temp.status = currStatus.value
      }
      const result = await axiosIns.get('/subscriptions', {
        params: temp,
      })
      const { subscriptions, total: totalList } = result.data.data
      list.value = subscriptions
      total.value = totalList
    } catch (error) {
      console.log(error)
    } finally {
      loading.value = false
    }
  }
  const search = () => {
    fetchUsers()
  }

  const subscriptionDetails = ref(null)
  const modalLoading = ref(false)

  const fetchSubscriptionDetails = async id => {
    modalLoading.value = true
    try {
      const { data } = await axiosIns.get(`/subscriptions/${id}`)
      subscriptionDetails.value = data.data
    } catch (err) {
      console.error('Failed to fetch subscription details:', err)
    } finally {
      modalLoading.value = false
    }
  }

  const openSubscriptionModal = async id => {
    ctx.root.$bvModal.show('subscription-details-modal')
    await fetchSubscriptionDetails(id)
  }

  const cancelling = ref(false)
  const cancelSubscription = async () => {
    if (!subscriptionDetails.value?.id) {
      console.warn('No subscription selected to cancel')
      return
    }
    try {
      cancelling.value = true
      await axiosIns.post(`/subscriptions/${subscriptionDetails.value.id}/cancel`, {
        plan_id: subscriptionDetails.value.plan_id,
        wallet_id: subscriptionDetails.value.wallet_id,
        payment_method_id: subscriptionDetails.value.payment_method_id || '',
      })
      await fetchSubscriptionDetails(subscriptionDetails.value.id)
      successNotification('Cancelled Successfully')
    } catch (error) {
      errorNotification('Failed to cancel subscription')
    } finally {
      cancelling.value = false
    }
  }

  fetchUsers()

  return {
    cancelling,
    cancelSubscription,
    fetchSubscriptionDetails,
    subscriptionDetails,
    openSubscriptionModal,
    modalLoading,
    tableColumns,
    statusOptions,
    currStatus,
    loading,
    queryParams,
    targetOptions,
    search,
    currTarget,
    fetchUsers,
    total,
    list,
  }
}
